import SharedOrderBilling from '@moko/ui/src/Work/billing/OrderBilling';
import {
  getOrderBilling,
  finalizeOrderBilling,
} from '../../services/orderBillingService';
const services = { load: getOrderBilling, finalize: finalizeOrderBilling };
export default function OrderBilling({ orderId }: { orderId: number }) {
  return <SharedOrderBilling orderId={orderId} services={services} />;
}
